export const AMOUNT_OF_SURVEYS_IN_PAST_FOR_SHOW_COUNTER = 2;
